enum SalesTotalTypeEnum {
    DAILY = "daily",
    WEEKLY = "weekly",
    MONTHLY = "monthly",
}

export default SalesTotalTypeEnum;
